import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si hace mucho tiempo que perdí a mamá?',
    a: 'Sí. El duelo no tiene fecha de vencimiento. Muchas personas atraviesan este proceso años después de la pérdida, cuando el dolor aparece en fechas especiales o en transiciones de vida importantes. Este material acompaña en cualquier momento del proceso.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu compra recibís un correo con el enlace de descarga. En menos de 5 minutos tenés todo el material en tu dispositivo.'
  }, {
    q: '¿Necesito tener conocimientos espirituales previos?',
    a: 'No. El material está escrito de forma amorosa, clara y accesible para cualquier persona, independientemente de sus creencias religiosas o espirituales. No impone ninguna doctrina, solo te invita a encontrar tu propia forma de conexión interior.'
  }, {
    q: '¿Es una terapia psicológica?',
    a: 'No reemplaza la terapia profesional. Es un acompañamiento espiritual y emocional complementario. Si sentís que el dolor es muy intenso o sostenido en el tiempo, te recomendamos también consultar con un profesional de salud mental.'
  }, {
    q: '¿Puedo usarlo en el celular o tablet?',
    a: 'Sí. El formato PDF es compatible con cualquier dispositivo. También podés imprimirlo si preferís trabajar en papel.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si sentís que el material no era lo que esperabas, te devolvemos el 100% del dinero sin preguntas ni formularios complicados.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-67">
      <div className="text-center mb-12" data-id="element-68">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-pinkDark" data-id="element-69">
          <span className="mr-3" data-id="element-70">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-71">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-pink/25 bg-white/80" data-id="element-72">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-73">
              <span className="font-medium pr-8 text-brand-pinkDark text-[14px]" data-id="element-74">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-pink transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-75" />
            </button>
            <AnimatePresence data-id="element-76">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-77">
                  <div className="px-6 pb-5 text-brand-text/80 border-t border-brand-pink/20 pt-4 bg-white/60 text-[13px] leading-relaxed" data-id="element-78">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};